(() => {
  const enhanceLegacyFitCard = (card) => {
    if (card.dataset.napModalReady === 'true') return;
    const summary = card.querySelector('summary');
    const panel = card.querySelector('.nap-fit-card__panel');
    if (!summary || !panel) return;
    card.dataset.napModalReady = 'true';
    summary.addEventListener('click', (event) => {
      event.preventDefault();
      const dialog = document.createElement('dialog');
      dialog.className = 'nap-fit-dialog';
      dialog.setAttribute('aria-label', 'Find your best fit');
      dialog.innerHTML = '<button class="nap-fit-dialog__close" type="button" aria-label="Close fit guide">×</button><div class="nap-fit-card__panel"></div>';
      dialog.querySelector('.nap-fit-card__panel').innerHTML = panel.innerHTML;
      document.body.append(dialog);
      const close = () => {
        if (dialog.open) dialog.close();
        dialog.remove();
        document.body.classList.remove('nap-fit-is-open');
      };
      dialog.querySelector('.nap-fit-dialog__close').addEventListener('click', close);
      dialog.addEventListener('click', (closeEvent) => { if (closeEvent.target === dialog) close(); });
      dialog.addEventListener('close', () => { if (document.body.contains(dialog)) dialog.remove(); });
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.body.classList.add('nap-fit-is-open');
    });
  };
  const scan = () => document.querySelectorAll('details.nap-fit-card[data-nap-fit-card]').forEach(enhanceLegacyFitCard);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
